import React from 'react';
import CommonLoader from '../common/Loader';

/**
 * Thin wrapper kept for backward compatibility.
 * All loaders now use the single dynamic loader in components/common/Loader.
 * Existing props (color, size, caption, containerHeight, minLoadTime) are forwarded.
 */
function Loader({ caption = 'Loading...', containerHeight = '200px', ...rest }) {
  return <CommonLoader caption={caption} containerHeight={containerHeight} {...rest} />;
}

export default Loader;
